"use strict"
import { getRequest, postRequest } from "@/services/RequestService";

export const getMassNotification = async (extraRequest = null) => {
  const base_route = extraRequest == null ? `mass-notifications` : `mass-notifications?date_from=${extraRequest.from}&date_to=${extraRequest.to}`;
  const response = await getRequest(base_route);
  return response;
}

export const storeMassNotification = async (request) => {
  const base_route = `mass-notifications`;
  const response = await postRequest(base_route, request);
  return response;
}

export const getMassNotificationDetails = async (notification_id) => {
  const base_route = `mass-notifications/${notification_id}`;
  const response = await getRequest(base_route);
  return response;
}

export const stopMassNotification = async (id, request) => {
  const base_route = `mass-notifications/stop/${id}`;
  const response = await postRequest(base_route, request);
  return response;
}

export const sendSms = async (id, request) => {
  const base_route = `mass-notifications/${id}/send`;
  const response = await postRequest(base_route, request);
  return response;
}

export const getAllEligibleUsers = async (notification_id, extraRequest = null) => {
  const base_route = extraRequest == null ? `mass-notifications/${notification_id}/all` : `mass-notifications/${notification_id}/all${extraRequest}`;
  const response = await getRequest(base_route);
  return response;
}
